module.exports = __webpack_public_path__ + "img/no-user.948ac3f.jpg";